import Pact from 'pact-lang-api'
import { ref } from 'vue'
import ENUMS from './components/Enums'

var validate_hash = function (x) {
    if (x.length > 1) {
        if (x[0] == "\"")
            x = x.slice(1)
        if (x[x.length - 1] == "\"")
            x = x.slice(0, x.length - 1)
    }
    return x
}

var pretty_minutes = function (x) {
    if (x < 60) {
        return x.toFixed(2) + "seconds"
    }
    else if (x < 60 * 60) {
        return (x / 60).toFixed(2) + " minutes"
    }
    else if (x < 60 * 60 * 24) {
        return (x / 60 / 60).toFixed(2) + " hours"
    }
    return (x / 60 / 60 / 24).toFixed(2) + " days"
}

const shorten_account = function (x) {
    if (x.length > 2) {
        if (x.substr(0, 2) == "k:") {
            return x.substr(0, 6) + "..." + x.substr(x.length - 2, 2)
        } else if (x.length > 10) {
            return x.substr(0, 6) + "..." + x.substr(x.length - 2, 2)
        }
    }
    return x
}

const get_nonce = function () {
    return new Date().toUTCString()
}


// const get_account_name = function (qthis) {
//     return qthis.$store.state.account_name
// }

const mymeta = function (acc, c_id) {
    // var acc = get_account_name(qthis)
    if (vget2(acc) == undefined)
        return Pact.lang.mkMeta("", c_id, 0.000001, 2e6, Math.round((new Date).getTime() / 1e3) - 10, 600)
    return Pact.lang.mkMeta(acc, c_id, 0.000001, 2e6, Math.round((new Date).getTime() / 1e3) - 10, 600)

}



var mpad = function (x) {
    while (x.length < 8) {
        x = '0' + x
    }
    return x
}

var date_formatter = function (x) {
    if (typeof x === 'object') {
        if ("timep" in x)
            return x.timep.split("T")[0]
        return x.time.split("T")[0]
    } else {
        // TODO handle error
    }
}

var countzeros = function (x) {
    var c = 0
    while (x[c] == '0') {
        c += 1
    }
    return c
}

var get_nft_strength_from_hash = function (x) {
    return countzeros(Array.from(Pact.crypto.base64UrlDecodeArr(x)).map((x) => mpad(x.toString(2))).reduce((x, y) => x + y))
}

var get_nft_strength_with_nonce = function (a, b) {
    return get_nft_strength_from_hash(Pact.crypto.hash(a + b))
}

var transfer_cap_maker = function (payer, dbts) {
    var tmp = Object.entries(dbts).filter((x) => x[1] > 0)
    var res = []
    for (var i in tmp) {
        res.push({
            "cap": {
                "name": "coin.TRANSFER",
                "args": [payer, tmp[i][0], parseFloat(tmp[i][1].toFixed(10))]
            }
        })
    }
    return res
}


var calc_no_front_run = function (nfr) {
    var nfrtmp = nfr.nft.get_id()
        + ":" +
        nfr.nft.get_curhash()
        + ":" +
        nfr.strongest_nonce_found
    var res = Pact.crypto.hash(nfrtmp)
    return res

}
var mypolling2 = function (qthis, reqkey, x, queryitem, apihosttmp) {
    return Pact.fetch.poll(queryitem.get_request_key(), apihosttmp).catch(x => { throw x }).then((res) => {
        if (Object.keys(res).length === 0) {
            vsetter(queryitem, "polls", vget(queryitem, "polls") + 1)
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    mypolling2(qthis, reqkey, x, queryitem, apihosttmp)
                        .catch(x => reject(x))
                        .then(x => resolve(x))
                }, 3000);
            }).catch(x => { throw x })
        } else {
            // qthis.$store.state.query_manager.
            // queryitem.try_set("status", ENUMS.QUERY_ITEM_STATUS.DONE)

            setTimeout(() => {
                get_wallet_manager(qthis).then(wal => wal.get_balance())

            }, 2000);

            return new PollingSuccess(qthis, queryitem, res)
        }
    })
}
var mypolling = function (qthis, reqkey, x) {
    var qi = new QueryItem(x, reqkey)
    qthis.$store.state.query_manager.add_query(qi)

    return get_wallet_manager(qthis).catch(x => { throw x }).then(wal => {
        var apihosttmp = wal.get_api_host()

        // console.log("_+_", x, queryitem.get_request_key())
        return mypolling2(qthis, reqkey, x, qi, apihosttmp)
    }).catch(e => {
        qi.try_set("status", ENUMS.QUERY_ITEM_STATUS.FAIL)
        throw e
    }).then(x => {
        qi.try_set("status", ENUMS.QUERY_ITEM_STATUS.DONE)

        return x
    })
}

var save_found_nonces = function (qthis) {
    if (get_nft_strength_with_nonce(qthis.nft.get_curhash(), vget(qthis, "strongest_nonce_found")) > qthis.nft.get_strength()) {
        qthis.appli.$store.state.found_nonces[qthis.nft.get_id()] = { nonce: vget(qthis, "strongest_nonce_found"), hashfor: qthis.nft.get_curhash() }
    }
    localStorage.found_nonces = JSON.stringify(qthis.appli.$store.state.found_nonces)
}

var delete_found_nonces = function (qthis, nft) {
    delete qthis.$store.state.found_nonces[nft.get_id()]
    localStorage.found_nonces = JSON.stringify(qthis.$store.state.found_nonces)
}

var EMOPOOLS = {}
var EMOLOOKUP = {}
setTimeout(() => {
    for (var i1 in ENUMS.EMOJI2) {
        EMOPOOLS[i1] = Object.keys(ENUMS.EMOJI2[i1]).map(x => Pact.crypto.hash(ENUMS.EMOJI2[i1][x])).sort()
    }


    for (var i in ENUMS.EMOJI2) {
        for (var j in ENUMS.EMOJI2[i]) {

            EMOLOOKUP[Pact.crypto.hash(ENUMS.EMOJI2[i][j])] = ENUMS.EMOJI2[i][j]
        }
    }

}, 1);



class NFTItem {
    appli;
    id;
    data;
    constructor(appli, x) {
        this.appli = appli
        this.id = x.id.int
        this.data = x
        if (appli.$store.state.found_nonces[this.get_id()] != undefined) {
            if (appli.$store.state.found_nonces[this.get_id()].hashfor != this.get_curhash()) {
                delete_found_nonces(this.appli, this)
            }
        }
    }
    is_in_grace() {
        if (new Date() - new Date(this.get_mint_date()) < 7 * 24 * 60 * 60 * 1000) {
            return true
        }
        return false
    }
    calc_emoj(x) {
        var mkey = Pact.crypto.hash(x + ":" + this.get_attrib())

        var c = 0;
        for (var i = 0; i < EMOPOOLS[x].length - 1; i++) {
            if ((mkey >= EMOPOOLS[x][i]) && (mkey < EMOPOOLS[x][i + 1])) {
                c = i
                break
            }
        }

        return EMOLOOKUP[EMOPOOLS[x][c]]

    }
    buy_nft() {
        var qthis = this

        var debtors = {

        }

        return get_account(qthis.appli).then(acc => {


            debtors[qthis.appli.$store.state.COAL_MAKER] = 0
            debtors[qthis.get_full_minter()] = 0
            debtors[qthis.get_full_owner()] = 0

            debtors[qthis.appli.$store.state.COAL_MAKER] += qthis.get_price() * 0.0201
            debtors[qthis.get_full_minter()] += qthis.get_price() * 0.0201
            debtors[qthis.get_full_owner()] += qthis.get_price() * 0.9601

            if (acc.name == qthis.get_full_minter()) {
                delete debtors[acc.name]
            }



            var cap_dbt = transfer_cap_maker(acc.name, debtors)


            var caps_buy = [
                {
                    "cap": {
                        "name": "coin.GAS",
                        "args": []
                    }
                }
            ]

            caps_buy = caps_buy.concat(cap_dbt)


            return get_wallet_manager(qthis.appli).then(wal => {
                var signingCmd = {
                    "pactCode": '(free.coal.buy-coal "' + qthis.get_id() + '")',
                    "caps": caps_buy,// nft.minter != qthis.$store.state.account.account ? caps_buy : caps_buy_minterbuyer,
                    "sender": acc.name,
                    "ttl": 600,
                    "gasLimit": qthis.appli.$store.state.settings.GAS_LIMIT,
                    "chainId": vget(wal, "chain_id"),
                    "gasPrice": 0.000001,
                    "envData": {
                        "coal-ks": [acc.public_key],
                        //   "account": localStorage.account
                    },
                    "signingPubKey": acc.public_key,
                    "networkId": vget(wal, "network_id")
                }
                return wal.sign(signingCmd).then(xsigned => {
                    return wal.send_local_signed(xsigned)
                        .catch(x => { throw x })
                        .then(() => wal.send(xsigned))
                        .catch(x => { throw x })
                        .then(x => { return new BuyNFT(qthis.appli, x) })
                })
            })

        });
    }
    set_remote_price(new_price, new_onsale, new_saleend) {
        var qthis = this
        return get_account(qthis.appli).then(acc => {

            return get_wallet_manager(qthis.appli).then(x => {
                var signingCmd = {
                    "pactCode": '(free.coal.set-sale-state "' + qthis.get_id() + '" ' + calc_price(new_price) + ' ' + Boolean(new_onsale) + ' ' + calc_price(new_saleend) + ')',
                    "caps": [],
                    "sender": acc.name,
                    "ttl": 600,
                    "gasLimit": qthis.appli.$store.state.settings.GAS_LIMIT,
                    "chainId": vget(x, "chain_id"),
                    "gasPrice": 0.000001,
                    "signingPubKey": [acc.public_key],
                    "networkId": vget(x, "network_id")
                }
                return x.sign(signingCmd).then(y => x.send(y))
            }).then(x => {
                return new SetNFTPrice(qthis.appli, x)
            })
        })
    }

    is_owned_by_wallet() {
        if (this.appli.$store.state.wallet_manager == undefined)
            return false
        return this.data.owner == this.appli.$store.state.wallet_manager.account_name
    }
    get_id() {
        return this.id
    }
    get_owner() {
        return shorten_account(this.data.owner)
    }
    get_strength() {
        return get_nft_strength_from_hash(this.data.curhash)
    }
    get_strength_with_nonce(nonce) {
        return get_nft_strength_from_hash(Pact.crypto.hash(this.data.curhash + nonce))
    }

    get_price() {
        return this.data.price
    }
    get_price_formatted() {
        return this.data.price
    }
    get_sale_state() {
        return this.data["on-sale"]
    }
    get_minter() {
        return shorten_account(this.data.minter)
    }
    get_date_formatted() {
        return date_formatter(this.data["mint-date"])
    }
    get_mint_date() {
        if (typeof this.data["mint-date"] == "object") {
            return Object.values(this.data["mint-date"])[0]
        }
        return this.data["mint-date"]

    }
    get_remaining_grace() {
        var res = new Date() - new Date(this.get_mint_date())
        res /= 1000
        return pretty_minutes(7 * 24 * 60 * 60 - res)

    }
    get_curhash() {
        return this.data["curhash"]
    }
    get_attrib() {
        return this.data["attrib"]
    }
    get_full_owner() {
        return this.data.owner
    }
    get_full_minter() {
        return this.data.minter
    }
}

var get_wallet_manager = function (qthis) {

    return new Promise(function (resolve) {
        if (qthis.$store.state.wallet_manager == undefined) {
            // reject()
            resolve(new WalletManager())
        } else {
            qthis.$store.state.wallet_manager.get_current_wallet_network().then(() => {
                resolve(qthis.$store.state.wallet_manager)

            })

        }
    })
}

var get_nft_manager = function (qthis) {
    return new Promise(function (resolve) {
        resolve(qthis.$store.state.nft_manager)
    })
}

var get_account = function (qthis) {
    return get_wallet_manager(qthis).then((x) => x.get_account_details())
}

var calc_price = function (t) {
    var res = 0.0
    if (t == '') {
        res = this.nft.price
    }
    else if (t == undefined) {
        res = this.nft.price
    } else {
        res = t
    }
    res = res + ""
    if (res.indexOf(".") > -1) {
        return res
    }
    return parseFloat(res + "").toFixed(1)
}

class MineItem {
    appli;
    nft;
    run_state;
    worker;
    strongest_nonce_found;
    strongest_nonce_found_strength;
    decoy_nonce;

    constructor(aapl, nft) {
        this.appli = aapl
        this.nft = nft

        this.run_state = ref(ENUMS.WORKER.STOPPED)
        this.strongest_nonce_found = ref(undefined)
        this.strongest_nonce_found_strength = ref(nft.get_strength())
        if (this.appli.$store.state.found_nonces[this.nft.get_id()] != undefined) {
            if (this.appli.$store.state.found_nonces[this.nft.get_id()].hashfor == this.nft.get_curhash()) {

                vsetter(this, "strongest_nonce_found", (this.appli.$store.state.found_nonces[this.nft.get_id()].nonce))
                vsetter(this, "strongest_nonce_found_strength", (get_nft_strength_with_nonce(this.nft.get_curhash(), vget(this, "strongest_nonce_found"))))
            }
        }
        this.decoy_nonce = ref("")


        this.initialize()
        this.set_hash()
        this.continue()

    }
    initialize() {
        var qthis = this
        vsetter(this, "run_state", ENUMS.WORKER.RUNNING)

        if (this.worker == undefined) {
            this.worker = new Worker('/miner.js')

            this.worker.onmessage = function (evv) {
                var ev = evv.data
                if (ev.res == "found") {
                    vsetter(qthis, "run_state", ENUMS.WORKER.STOPPED)

                    vsetter(qthis, "strongest_nonce_found", ev.data.nonce)

                    vsetter(qthis, "strongest_nonce_found_strength", qthis.nft.get_strength_with_nonce(ev.data.nonce))
                    save_found_nonces(qthis)

                } else if (ev.res == "notfoundyet") {
                    vsetter(qthis, "decoy_nonce", ev.data)
                    qthis.worker.postMessage(JSON.stringify({ type: "continue" }))

                }
            }

        }
    }
    close_mine() {
        if (this.worker != undefined)
            this.worker.terminate()
        this.worker = undefined
        vsetter(this, "run_state", ENUMS.WORKER.STOPPED)
    }
    continue() {
        if (this.worker == undefined) {
            this.initialize()
        }

        this.worker.postMessage(JSON.stringify({ type: "continue" }))
        vsetter(this, "run_state", ENUMS.WORKER.RUNNING)

    }
    set_hash() {
        this.worker.postMessage(JSON.stringify({
            type: "set_hash", data: {
                curhash: this.nft.get_curhash()
                , strongest_nonce: vget(this, "strongest_nonce_found")
                , strongest_nonce_found_strength: vget(this, "strongest_nonce_found_strength")
            }
        }))
    }

}
class NFRItem {
    nft;
    appli;
    type;
    strongest_nonce_found;
    strongest_nonce_found_strength;
    constructor(appli, nft, strongest_nonce_found) {
        this.appli = appli
        this.nft = nft
        this.strongest_nonce_found = strongest_nonce_found
        this.type = ENUMS.HEIST_TYPE.MINED
        if (strongest_nonce_found == undefined) {
            this.type = ENUMS.HEIST_TYPE.MANUAL

        }
    }
    lock_nfr() {
        var qthis = this

        return qthis.query_nfr().catch(x => {
            console.log("LOCKNFR", x)
            if (x instanceof SigningError) { throw x }
            else if (x instanceof QueryNFRNotFound) {
                return get_account(qthis.appli).then((acc) => {
                    return get_wallet_manager(qthis.appli).then(wal => {
                        var signingCmd = {
                            "pactCode": "(free.coal.no-front-running-me \"" + calc_no_front_run(qthis) + "\")",
                            "caps": [

                            ],
                            "sender": acc.name,
                            "ttl": 600,
                            "gasLimit": qthis.appli.$store.state.settings.GAS_LIMIT,
                            "chainId": vget(wal, "chain_id"),
                            "gasPrice": 0.000001,
                            "envData": {
                                "nfr-ks": [acc.public_key],
                            },
                            "signingPubKey": acc.public_key,
                            "networkId": vget(wal, "network_id")
                        }

                        return wal.sign(signingCmd).catch(x => { throw x })
                            .then(y => wal.send(y).then(x => {
                                return new LockNFR(qthis.appli, x)

                                // try {

                                //     x = Object.values(x)[0]

                                //     if (x.result.status == "failure") {
                                //         reject({ result: "failure" })

                                //     } else {
                                //         resolve({ result: "success" })
                                //     }
                                // } catch (error) {
                                //     reject({ result: "failure" })

                                // }
                            })
                            )
                    })

                })
            }
        }).then(x => {
            if (x instanceof QueryNFR) {
                return x
            } else {
                throw new Error(["unknown", x])
            }
        })

    }
    query_nfr() {
        var qthis = this
        return get_account(qthis.appli).then(acc => {


            return get_wallet_manager(qthis.appli).then(x => {
                var signingCmd = {
                    "pactCode": "(free.coal.verify-nfr \"" + calc_no_front_run(qthis) + "\")",
                    "caps": [

                    ],
                    "sender": acc.name,
                    "ttl": 600,
                    "gasLimit": qthis.appli.$store.state.settings.GAS_LIMIT,
                    "chainId": vget(x, "chain_id"),
                    "gasPrice": 0.000001,
                    "envData": {
                        "nfr-ks": [acc.public_key],
                    },
                    "signingPubKey": acc.public_key,
                    "networkId": vget(x, "network_id")
                }
                return x.sign(signingCmd).catch(x => { throw x }).then(y => {
                    return x.send_local_signed(y).catch(x => {
                        console.log(77, 11, x)
                        if (x instanceof SigningError) throw x
                        if (x instanceof KeysetFailure) throw x

                        throw new QueryNFRError(x)
                    }).then(x => {
                        console.log(777777, x)
                        return new QueryNFR(qthis.appli, x)
                    })
                })
            })
        })


    }
    verify_nfr() {
        var qthis = this
        return qthis.query_nfr().catch(x => {
            throw x
        }).then(qres => {
            console.log("123123", qres)
            if (qres instanceof QueryNFR) {
                return qres
            } else {

                return get_wallet_manager(qthis.appli).then(wal => {
                    return wal.send(qres.toBeFetched)
                }).catch(x => { throw x }).then(x => {
                    return new VerifyNFR(qthis, x)
                    // x = Object.values(x)[0]
                    // if (x.result.status == "failure") {
                    //     // fetchResult.result.error.message
                    //     return get_wallet_manager(qthis.appli).then(wal => {

                    //         wal.send_local_signed(qres.toBeFetched).then(x => {
                    //             // qthis.appli.$store.state.query_manager.set_kv(x.fetchResult.reqKey, "status", ENUMS.QUERY_ITEM_STATUS.FAIL)
                    //             // if (x.fetchResult.result.error.message.toLowerCase().indexOf("row not found") > -1) {
                    //             //     qthis.appli.$store.state.query_manager.set_kv(x.fetchResult.reqKey, "reason", "no NFR exist")
                    //             //     throw new NFRError({ result: ENUMS.NFR_STATE.NOT_FOUND })
                    //             // } else if (x.fetchResult.result.error.message.toLowerCase().indexOf("keyset failure") > -1) {
                    //             //     qthis.appli.$store.state.query_manager.set_kv(x.fetchResult.reqKey, "reason", "NFR not in name")

                    //             //     throw new NFRError({ result: ENUMS.NFR_STATE.LOCKED_IN_OTHER_NAME })
                    //             // }
                    //             // qthis.appli.$store.state.query_manager.set_kv(x.fetchResult.reqKey, "reason", "NFR not found")

                    //             // throw new NFRError({ result: ENUMS.NFR_STATE.NOT_FOUND })

                    //             throw new NFRError(x)


                    //         })
                    //     })
                    // } else {
                    //     return new NFRSuccess({ result: ENUMS.NFR_STATE.LOCKED_IN_MY_NAME })
                    // }
                })
            }


        })

    }
    submit_nonce() {
        var qthis = this

        var meth = "strengthen-nft"
        return get_account(qthis.appli).then(acc => {
            if (qthis.nft.get_full_owner() != acc.name) {
                meth = "steal-nft"
            }

            return get_wallet_manager(qthis.appli).then(wal => {
                var signingCmd = {
                    "pactCode": "(free.coal." + meth + " \"" + qthis.nft.get_id() + "\" \"" + validate_hash(qthis.strongest_nonce_found) + "\")",
                    "caps": [],
                    "sender": acc.name,
                    "ttl": 600,
                    "gasLimit": qthis.appli.$store.state.settings.GAS_LIMIT,
                    "chainId": vget(wal, "chain_id"),
                    "gasPrice": 0.000001,
                    "envData": {
                        "nfr-keyset": [acc.public_key],
                    },
                    "signingPubKey": acc.public_key,
                    "networkId": vget(wal, "network_id")
                }

                return wal.sign(signingCmd).catch(x => { throw x }).then(y => wal.send(y)).catch(x => { throw x }).then(x => {
                    return new SubmitNFR(qthis.appli, x)
                })
            })

        })
    }

}
class NFRManager {
    appli;
    nfrs;
    constructor(appli) {
        this.appli = appli
        this.nfrs = {}
    }

    add_nfr(mineitem) {
        this.nfrs[mineitem.nft.get_id()] = new NFRItem(this.appli, mineitem.nft, mineitem.strongest_nonce_found)
        this.appli.$store.commit("changeView", ENUMS.VIEWS.HEISTS)

    }
    add_nfr_from_nft(nft) {
        this.nfrs[nft.get_id()] = new NFRItem(this.appli, nft)
        this.appli.$store.commit("changeView", ENUMS.VIEWS.HEISTS)

    }
    clean(wrkk) {
        delete this.nfrs[wrkk]
    }
}
class MineManager {
    appli;
    mine;
    constructor(appli) {
        this.appli = appli
        this.mine = {}
    }
    clean(wrkk) {
        this.mine[wrkk].close_mine()
        delete this.mine[wrkk]

    }
    add_miner(nft) {
        var qthis = this
        if (nft.get_id() in this.mine) {
            console.log("?")
        } else {
            this.mine[nft.get_id()] = new MineItem(this.appli, nft)

        }
        this.appli.$store.commit("changeView", ENUMS.VIEWS.MINE)

        // if (qthis.appli.$store.state.mine_cur > -1) {
        setTimeout(() => {
            qthis.appli.$store.state.mine_cur = nft.get_id()
            document.getElementById('minele-' + nft.get_id()).scrollIntoView()
        }, 100);
        // }
    }
}

class NFTManager {
    appli;
    constructor(appli) {
        this.appli = appli
    }

    list_nfts_from(seeker) {
        var qthis = this

        return get_account(qthis.appli).then(acc => {
            return get_wallet_manager(qthis.appli).then(x => {
                var mcmd = {
                    type: "exec",
                    pactCode: "(free.coal.load-from " + seeker + ")",
                    nonce: get_nonce(),
                    envData: {},
                    chainId: vget(x, "chain_id"),
                    meta: mymeta(acc.name, vget(x, "chain_id")),
                    networkId: vget(x, "network_id")

                }
                return x.send_local_unsigned(mcmd)
            }).then((x) => {
                return new ListNFTs(qthis.appli, x)
            })
        })
    }

    mint_coal() {
        var qthis = this

        return get_account(qthis.appli).then((acc) => {
            return get_wallet_manager(qthis.appli).then((wal) => {
                var TEHPRICE = 13.69

                var signingCmd = {
                    "pactCode": "(free.coal.mint-coal)",
                    "caps": [
                        {
                            "cap": {
                                "name": "coin.TRANSFER",
                                "args": [acc.name, qthis.appli.$store.state.COAL_MAKER, TEHPRICE]
                            }
                        },
                        {
                            "cap": {
                                "name": "coin.GAS",
                                "args": []
                            }
                        }
                    ],
                    "sender": acc.name,
                    "ttl": 600,
                    "gasLimit": qthis.appli.$store.state.settings.GAS_LIMIT,
                    "chainId": vget(wal, "chain_id"),
                    "gasPrice": 0.000001,
                    "envData": {
                        "coal-ks": [acc.public_key],
                        //   "account": localStorage.account
                    },
                    "signingPubKey": acc.public_key,
                    "networkId": vget(wal, "network_id")
                }

                return wal.sign(signingCmd)
                    .catch(x => { throw x })
                    .then(msigned => {
                        return wal.send_local_signed(msigned).catch(x => { throw x }).then(x => {
                            console.log("3266666", x)
                        }).catch(x => { throw x })
                            .then(() => wal.send(msigned))
                            .catch(x => { throw x })
                            .then(x => {
                                console.log("xxx", x)
                                return new MintNFT(qthis.appli, x)
                            })
                    }).catch(x => { throw x })
            })

        })

    }



    make_nft_items(y) {
        var qthis = this
        if (y == undefined) {
            return []
        }
        return y.map((x) => new NFTItem(qthis.appli, x))
    }

    load_on_sale() {
        var qthis = this
        return get_account(qthis.appli).then(acc => {
            return get_wallet_manager(qthis.appli).then(wal => {
                return wal.send_local_unsigned({
                    type: "exec",
                    // pactCode: "(free.coal.load-on-sale " + this.seeker + ")",
                    pactCode: "(free.coal.load-on-sale)",
                    nonce: get_nonce(),
                    envData: {},
                    meta: mymeta(acc.name, vget(wal, "chain_id")),
                    networkId: vget(wal, "network_id")

                }, wal.get_api_host()).then((x) => {
                    return new OnSaleNFTs(qthis.appli, x)
                })
            })
        })
    }

    all_owned_by_wallet() {
        var qthis = this
        return get_account(qthis.appli).then((x) => qthis.all_owned_by(x.name))
    }

    all_owned_by(acc) {
        var qthis = this
        return get_wallet_manager(qthis.appli).then(wal => {
            return wal.send_local_unsigned({
                type: "exec",
                pactCode: "(free.coal.all-owned-by \"" + acc + "\")",
                nonce: get_nonce(),
                envData: {},
                meta: mymeta(acc, vget(wal, "chain_id")),
                networkId: vget(wal, "network_id")

            }, wal.get_api_host()).then(function (x) {
                return new MyNFTs(qthis.appli, x)
            })
        })

    }
}

var id_sort = function () {
    return function (a, b) { return a.get_id() - b.get_id() }
}
var query_sort = function () {
    return function (a, b) { return b.get_time() - a.get_time() }

}

var vget = function (x, k) {
    if (typeof x[k] == 'object') {
        if ('value' in x[k]) {

            return x[k].value
        }
    } else {
        return x[k]
    }
}
var vget2 = function (x) {
    if (typeof x == 'object') {
        if ('value' in x) {

            return x.value
        }
    } else {
        return x
    }
}
var vsetter = function (x, ks, v) {
    if (Array.isArray(ks)) {
        if (ks.length > 1) {
            vsetter(x[ks[0]], ks.splice(1), v)
        } else {
            if (typeof x[ks[0]] === 'object') {
                if ('value' in x[ks[0]]) {
                    x[ks[0]].value = v
                    return
                }
            }

            x[ks[0]] = v
        }
    } else {
        if (typeof x[ks] === 'object') {
            if ('value' in x[ks]) {
                x[ks].value = v
                return
            }
        }

        x[ks] = v
    }
}

class WalletManager {
    appli;
    connection_state;
    chain_id;
    account_name;
    public_key;
    network_id;
    balance;
    // connection_state;
    // account_name;
    // chain_id;
    // public_key;
    // private_key;

    constructor(appli) {
        this.appli = appli
        this.connection_state = ref(ENUMS.WALLET.NOT_AVAILABLE)
        this.chain_id = ref("13")
        this.account_name = ref(undefined)
        this.public_key = ref(undefined)
        this.network_id = ref(undefined)
        this.balance = ref(undefined)



    }
    send_local_unsigned(xunsigned) {
        var qthis = this
        return Pact.fetch.local(xunsigned, qthis.get_api_host())
            .then(x => { return new LocalUnsignedOutput({ fetchResult: x, toBeFetched: xunsigned }) })

    }

    get_api_host() {
        var qthis = this
        if (vget(qthis, "network_id") == "testnet04") {
            return "https://api.testnet.chainweb.com/chainweb/0.0/testnet04/chain/1/pact"

        } else {
            return "https://api.chainweb.com/chainweb/0.0/mainnet01/chain/13/pact"


        }

    }
    send_local_signed(xsigned) {
        var qthis = this
        console.log("5555555", xsigned)
        return fetch(qthis.get_api_host() + "/api/v1/local", {
            'method': 'POST',
            'headers': {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "body": JSON.stringify(xsigned.get_signed_cmd())
        }).then(x => x.text()).then(x => {
            return new LocalSignedOutput({ fetchResult: JSON.parse(x), toBeFetched: xsigned })
        })
    }
    get_account_details() {
        var qthis = this
        return new Promise(function (resolve, reject) {
            if (qthis.account_name == undefined) {
                // TODO do kda_reueststatus
                reject()
            } else {
                resolve({ name: qthis.account_name, public_key: qthis.public_key })
            }
        })
    }
    get_balance() {
        var qthis = this

        var mcmd = {
            type: "exec",
            pactCode: "(coin.get-balance \"" + vget(qthis, "account_name") + "\")",
            nonce: get_nonce(),
            envData: {},
            chainId: vget(qthis, "chain_id"),
            meta: mymeta(vget(qthis, "account_name"), vget(qthis, "chain_id")),
            networkId: vget(qthis, "network_id")

        }
        return qthis.send_local_unsigned(mcmd).then(x => {
            if (x instanceof LocalUnsignedOutput) {
                var res = new BalanceResult(qthis.appli, x)
                if (res.get_balance() > 0.001) {
                    vsetter(qthis, "balance", res.get_balance().toFixed(3))
                } else {
                    vsetter(qthis, "balance", res.get_balance().toExponential())
                }
                return res

            }
        })
    }
    // get_account_name() { return this.account_name }
    // connect() { }
    // get_connection_state() { return this.connection_state }
    // get_chain_id() { return this.chain_id }
}

class XWallet extends WalletManager {


    constructor(appli) {
        super(appli)


        // this.connection_state.value = ENUMS.WALLET.NOT_AVAILABLE
        var qthis = this


        window.kadena.on('res_checkStatus', (x) => {
            if (x.result.status == "fail") {
                vsetter(qthis, "connection_state", ENUMS.WALLET.DISCONNECTED)
            } else {
                // vsetter(qthis, "chain_id", x.result.account.chainId)
                vsetter(qthis, "account_name", x.result.account.account)
                vsetter(qthis, "public_key", x.result.account.publicKey)
                vsetter(qthis, "connection_state", ENUMS.WALLET.CONNECED)
            }
        })
        window.kadena.on('res_accountChange', (event) => {
            console.log("acc_change", event)
            qthis.appli.$store.state.last_view_focus = this.appli.$store.state.current_view
            this.appli.$store.commit("changeView", ENUMS.VIEWS.MAIN)


            qthis.connect()

        })
        window.kadena.request({
            method: 'kda_getNetwork',
        }).then(mnet => {

            window.kadena.request({
                method: 'kda_checkStatus',
                networkId: mnet.networkId
            }).then((x) => {
                if (x.status == "success") {

                    // vsetter(qthis, "chain_id", x.account.chainId)
                    vsetter(qthis, "account_name", x.account.account)
                    vsetter(qthis, "public_key", x.account.publicKey)
                    vsetter(qthis, "connection_state", ENUMS.WALLET.CONNECED)

                } else {
                    qthis.connect()

                }

            })
        })

    }

    get_current_wallet_network() {
        var qthis = this
        return new Promise(function (resolve) {

            window.kadena.request({
                method: 'kda_getNetwork',
            }).then(x => {
                vsetter(qthis, "chain_id", "13")
                vsetter(qthis, "network_id", x.networkId)
                if (x.networkId == "testnet04") {
                    vsetter(qthis, "chain_id", "1")
                }
                resolve(qthis)
            })
        })
    }

    send(signsuccess) {
        console.log("msending", signsuccess)
        var qthis = this
        if (signsuccess instanceof SigningSuccess) {
            return fetch(qthis.get_api_host() + "/api/v1/send", {
                'method': 'POST',
                'headers': {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify({ 'cmds': [signsuccess.get_signed_cmd()] })
            }).then(x => x.text()).then(reqkey => {
                console.log(33333, reqkey)
                var qthis = this
                if (signsuccess instanceof SigningSuccess) {
                    return mypolling(qthis.appli, reqkey, signsuccess)
                } else {
                    throw new OutputError_M(["not LocalSignedOutput", signsuccess])
                }
            })
            // console.log("11111", JSON.stringify({ 'cmds': [xcmd.get_signed_cmd()] }))
            // return Pact.fetch.send(JSON.stringify({ 'cmds': [xcmd.get_signed_cmd()] }), qthis.get_api_host()).then(x => {
            //     console.log("tsend,", x)
            // })
        } else {
            throw new OutputError_M(["message was not signed", signsuccess])
        }
    }



    sign(signingCmd) {
        var qthis = this

        return window.kadena.request({
            method: 'kda_requestSign',
            data: {
                networkId: vget(qthis, "network_id"),
                signingCmd: signingCmd
            },
        }).then(x => {
            return new SigningSuccess(x)

        })
    }

    disconnect() {
        var qthis = this
        return new Promise(function (resolve, reject) {

            window.kadena.request({
                method: 'kda_disconnect',
                networkId: vget(qthis, "network_id"),
            }).then((x) => {
                if (x.result.status == "success") {
                    // vsetter(qthis, "chain_id", undefined)
                    vsetter(qthis, "account_name", undefined)
                    vsetter(qthis, "public_key", undefined)
                    vsetter(qthis, "connection_state", ENUMS.WALLET.DISCONNECTED)
                    resolve()
                    // a
                } else {
                    reject()
                    // TODO 
                }
            })
        })
    }
    connect() {
        var qthis = this
        return new Promise(function (resolve, reject) {
            window.kadena.request({
                method: 'kda_getNetwork',
            }).then(mnet => {
                window.kadena.request({
                    method: 'kda_connect',
                    networkId: mnet.networkId,
                }).then((x) => {

                    if (x.status == "success") {
                        vsetter(qthis, "chain_id", x.account.chainId)
                        vsetter(qthis, "account_name", x.account.account)
                        vsetter(qthis, "public_key", x.account.publicKey)
                        vsetter(qthis, "connection_state", ENUMS.WALLET.CONNECED)
                        resolve()
                    } else {
                        // TODO 
                        reject()
                    }
                })
            })
        })

    }
}

class Output_M {
    gas;
    status;
    data;
    constructor() {
    }
    get_data() {
        return this.data
    }
    get_status() {
        return this.status
    }
}
class SendOutput extends Output_M {
    constructor(x) {
        super()
        if (Object.keys(x).length != 1) {
            throw new Error("Not implemented")
        } else {
            var tmp = Object.values(x)[0]
            this.gas = tmp.gas
            if (tmp.result.error != undefined) {
                throw new OutputError_M(x)
            } else {
                this.status = tmp.result.status
                this.data = tmp.result.data
            }
        }
    }
}
class LocalOutput_M extends Output_M {
    constructor(x) {
        super()
        console.log("000000", x)
        if (x.fetchResult.result.status != "success") {
            var tmp = x.fetchResult.result.error.message.toLowerCase()
            if (tmp.indexOf("insufficient funds") > -1) {
                throw new InsufficientFundsError(x)
            } else if ((tmp.indexOf("gas limit") > -1) && (tmp.indexOf("exceed") > -1)) {
                throw new GasLimitExceedError(x)
            } else if (tmp.indexOf("keyset failure") > -1) {
                throw new KeysetFailure(x)
            }
            throw new OutputError_M(x)
        }
        this.gas = x.fetchResult.gas
        this.status = x.fetchResult.result.status
        this.data = x.fetchResult.result.data
    }
}
class LocalUnsignedOutput extends LocalOutput_M {
    constructor(x) {
        // console.log("unsigned", x)
        super(x)
    }
}
class LocalSignedOutput extends LocalOutput_M {
    constructor(x) {
        // console.log("signed", x)
        super(x)
    }
}
class OutputError_M {
    data;
    constructor(x) {
        this.data = x
    }
    get_data() {
        return this.data
    }
}
class InsufficientFundsError extends OutputError_M {
    constructor(x) {
        super(x)
    }
}
class GasLimitExceedError extends OutputError_M {
    constructor(x) {
        super(x)
    }
}
class KeysetFailure extends OutputError_M {
    constructor(x) {
        super(x)
    }
}


// =====================================
class Error_M { }
class Success_M {
    appli;
    constructor(appli) {
        this.appli = appli
    }
    get_appli() {
        return this.appli
    }
}
class BalanceError extends Error_M { }
class BalanceResult extends Success_M {
    price;
    constructor(appli, x) {
        super(appli)
        if (x instanceof Output_M) {
            this.price = x.get_data()
        } else {
            throw new BalanceError(x)
        }

    }
    get_balance() {
        return this.price
    }
}
class PollingSuccess extends SendOutput {
    constructor(appli, qi, x) {
        console.log("polsuc", x, qi, appli)
        super(x)
    }
}
class ListNFTsError extends Error_M { }
class ListNFTs extends Success_M {
    teh_nfts;
    constructor(appli, x) {
        super(appli)
        var qthis = this
        if (x instanceof Output_M) {
            this.teh_nfts = x.get_data().map(x => new NFTItem(qthis.get_appli(), x)).sort(id_sort())
        } else {
            throw new ListNFTsError(x)
        }
    }
    get_nfts() {
        return this.teh_nfts
    }
}

class OnSaleNFTsError extends Error_M { }
class OnSaleNFTs extends Success_M {
    teh_nfts;
    constructor(appli, x) {
        super(appli)
        var qthis = this
        if (x instanceof Output_M) {
            this.teh_nfts = x.get_data().map(x => new NFTItem(qthis.get_appli(), x)).sort(id_sort())
        } else {
            throw new OnSaleNFTsError(x)
        }
    }
    get_nfts() {
        return this.teh_nfts
    }
}
class MyNFTsError extends Error_M { }
class MyNFTs extends Success_M {
    teh_nfts;
    constructor(appli, x) {
        super(appli)
        var qthis = this
        if (x instanceof Output_M) {
            this.teh_nfts = x.get_data().map(x => new NFTItem(qthis.get_appli(), x)).sort(id_sort())
        } else {
            throw new MyNFTsError(x)
        }
    }
    get_nfts() {
        return this.teh_nfts
    }
}
class QueryNFRNotFound extends Error_M {

}
class QueryNFRError extends Error_M {
    constructor(x) {
        super()
        console.log(x, 100000)
        var tmp = x.get_data().fetchResult.result.error.message.toLowerCase()
        if (tmp.indexOf("row not found") > -1) {
            throw new QueryNFRNotFound()
        }
        throw this
    }
}
class QueryNFR extends Success_M {
    constructor(appli, x) {
        super(appli)
        console.log("QNFR", x)
    }
}
class VerifyNFR extends Success_M {
    constructor(appli, x) {
        super(appli)
        console.log("VNFR", x)
    }
}

class SetNFTPrice extends Success_M {
    constructor(appli, x) {
        super(appli)
        console.log("SNP", x)

    }
}

class BuyNFT extends Success_M {
    constructor(appli, x) {
        super(appli)
        console.log("BNF", x)

    }
}
class MintNFT extends Success_M {
    constructor(appli, x) {
        super(appli)
        console.log("MNTTTT", x)
    }
}
class LockNFR extends Success_M {
    constructor(appli, x) {
        super(appli)
        console.log("LOCKNFR", x)
    }
}
class SubmitNFR extends Success_M {
    constructor(appli, x) {
        super(appli)
        console.log("SUBNFR", x)
    }
}
class SigningError {
    data;
    constructor(x) {
        this.data = x
    }
}

class SigningSuccess {
    data;
    status;
    xcmd;
    constructor(x) {
        console.log(999, x)
        if (x.status == "success") {
            try {
                var jsx = JSON.parse(x.signedCmd.cmd)
                this.data = jsx
                this.status = x.status
                console.log("SIGSSS", jsx)
                this.xcmd = x
            } catch (error) {
                throw new SigningError(error)
            }
        } else {
            throw new SigningError(x)
        }

    }

    get_signed_cmd() {
        return this.xcmd.signedCmd
    }
}

class QueryManager {
    queries;
    appli;
    unresolved;
    constructor(aapl) {
        this.queries = {}
        this.appli = aapl
    }
    set_kv(k, kk, v) {
        if (this.queries[k] != undefined) {
            this.queries[k].try_set(kk, v)
        } else {
            console.log("not found", k, v)
        }
    }
    add_query(q) {
        this.queries[q.hash] = q
    }
    has_loading() {
        var tmp = Object.values(this.queries)
        for (var i in tmp) {
            if (vget(tmp[i], "status") == ENUMS.QUERY_ITEM_STATUS.LOADING) {
                return true
            }

        }
        return false
    }
}

var remove_all = function (a, b) {
    while (a.indexOf(b) > -1) {
        a = a.replace(b, "")
    }
    return a
}

class QueryItem {
    hash;
    importance;
    polls;
    mcmd;
    status;
    reason;
    mtime;
    reqkey;

    get_time() {
        return this.mtime
    }

    try_set(mk, mv) {
        if (mk == "status" && vget(this, "status") == ENUMS.QUERY_ITEM_STATUS.FAIL) return
        var qthis = this
        vsetter(qthis, mk, mv)
    }

    get_request_key() {
        return JSON.parse(this.reqkey)
    }
    constructor(xcmd, reqkey) {
        this.importance = ENUMS.QUERY_IMPORTANCE.NOT_IMPORTANT
        this.polls = ref(0)
        this.mtime = new Date().getTime()
        this.status = ref(ENUMS.QUERY_ITEM_STATUS.LOADING)
        this.reason = ref("")
        this.reqkey = reqkey
        console.log("||||--||||", reqkey, xcmd)
        // var x = xx
        // try {
        //     x = JSON.parse(x)
        // } catch (error) {
        //     x = xx
        // }

        var tmpl = xcmd.xcmd.signedCmd.cmd.split("free.coal.")[1]
        var a = tmpl.indexOf(")")
        var b = tmpl.indexOf(" ")
        var func = tmpl.slice(0, Math.min(a, b))
        var args = tmpl.slice(Math.min(a, b), a).split(" ")
        args = args.filter(x => x != '')



        if (func.startsWith("set-sale-")) {
            func = "set price"
        } else if (func.startsWith("mint")) {
            func = "minting"
        } else if (func.startsWith("lock-nfr")) {
            func = "locking nfr"
        } else if (func.startsWith("verify-nfr")) {
            func = "verifying nfr"
        } else if (func.startsWith("submit-nfr")) {
            func = "submitting nfr"
        } else if (func.startsWith("steal")) {
            func = "stealing nft"
        } else if (func.startsWith("buy")) {
            func = "buying nft"
        }

        this.mcmd = func



        if (args.length > 0) {
            var tmpi = args[0]
            if (tmpi.indexOf("\"") > 0) {
                tmpi = remove_all(tmpi, "\"")
                tmpi = remove_all(tmpi, "\\")
            }
            if (func == "set price") {
                if (args[2] == 'false') {
                    this.mcmd = "remove sale of #" + tmpi
                } else {
                    this.mcmd += " of #" + tmpi + " to " + args[1]
                }
            }
            else if (func == "locking nfr")
                this.mcmd += " for #" + tmpi
            else if (func == "stealing nft")
                this.mcmd += " #" + tmpi
            else if (func == "buying nft")
                this.mcmd += " #" + tmpi // TODO add price


        }


        // if (x.requestKeys != undefined) {
        //     this.hash = x.requestKeys[0]

        // } else {
        //     console.log("QIerror", typeof x)
        //     console.log(Object.keys(x))
        // }

    }

}

// class TrackManager {
//     appli;
//     constructor(aapl) {
//         this.appli = aapl
//     }

//     add_event(e){

//     }


// }

export {
    shorten_account
    , get_nonce
    , mymeta
    , get_nft_strength_from_hash
    , date_formatter
    , get_nft_strength_with_nonce
    , transfer_cap_maker
    , calc_no_front_run
    , mypolling
    , save_found_nonces
    , delete_found_nonces
    , get_nft_manager
    , get_wallet_manager
    , get_account
    , calc_price
    , XWallet
    , NFTManager
    , NFTItem
    , MineManager
    , NFRManager
    , vsetter
    , vget2
    , vget
    , QueryManager
    , QueryItem
    , query_sort
    , QueryNFRNotFound
    , QueryNFR
    , VerifyNFR
    , SigningError
    , InsufficientFundsError
    , GasLimitExceedError
    , KeysetFailure
    , SubmitNFR
    , MintNFT
    , validate_hash
    // , TrackManager
}

// window.sac_load_my_nfts = function(clb){
//     all_owned_by_wallet().then(x=>clb(x))
// }
// TODO strenghen-nft needs adding id for query shower